import React, { useState } from 'react';

import {
  FilterTasksModal,
  SaveTaskModal
} from 'modules/components/layer17';

import { ActivityHeaderSectionWithMetricsLayout } from 'modules/components/layer32';
import { TaskSummaryMetricsSection } from 'modules/components/layer35';

import { useAccessState } from 'modules/common';

import { Button } from '@mui/material';



export type TasksHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: TasksHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithMetricsLayout.FC
      title='Tasks'
      subtitle=''
      actionButtons={<ActionButtonsGroup />}
      metrics={(
        <TaskSummaryMetricsSection.FC />
      )}
    />
  );
};


type ActionButtonsGroup = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isSaveTaskVisible,
    setIsSaveTaskVisible
  ] = useState(false);

  const access = useAccessState('Task');

  return (
    <>
      {isVisible && (
        <FilterTasksModal.FC
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
          id=''
        />
      )}
      {isSaveTaskVisible && (
        <SaveTaskModal.FC
          isVisible={isSaveTaskVisible}
          handleClose={() => setIsSaveTaskVisible(() => false)}
          id=''
        />
      )}
      <Button
        variant='outlined'
        color='primary'
        onClick={() => setIsVisible(() => true)}
      >
        Filter
      </Button>
      <Button
        disabled={!access.create}
        variant='contained'
        color='primary'
        onClick={() => setIsSaveTaskVisible(() => true)}
      >
        Create New Task
      </Button>

    </>
  );
};

